import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as Inpc from 'inpc/components';
import InpcFormHandlers from 'inpc/containers/InpcFormHandlers';

import { getIsSaving, getIsFetching, getEditing } from 'inpc/selectors';
import { getCompany } from 'auth/selectors';

class InpcFormContainer extends Component {
  render = () => (
    <InpcFormHandlers
      render={({ isSubmitted, handleValueChange, handleValidation, handleSubmit, isSaving }) => (
        <Inpc.FormView
          company={this.props.company}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          inpc={this.props.inpc}
          isFetching={this.props.isFetching}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  inpc: getEditing(state),
  company: getCompany(state),
});

export default connect(mapStateToProps, null)(InpcFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/containers/InpcFormContainer.js